// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ECharts from "echarts";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import router from "./router";
import "./permission"; // 路由守卫

// // 导入tailwind
import "@/assets/tailwind.css";

// 导入fontawesome
import "@fortawesome/fontawesome-free/css/all.min.css";

// 导入vuex
import store from "./store";

// import { debounce } from "@/utils/debounce.js";
// Vue.prototype.$debounce = debounce;

Vue.config.productionTip = false;
Vue.use(ElementUI);
// Vue.component('v-chart', ECharts)
Vue.prototype.$echarts = ECharts;

import "./plugins/element.js";

import "./utils/websocket.js"; // 引入 WebSocket 工具

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js